import React from 'react'

function Tv() {
  return (
    <div>
      <section className='internal-page-wraper'>
        <div className='container'>
            <div className='row h-100 align-items-center justify-content-center text-center'>
                <div className='col-12 mt-5 pt-5'>
                    <h1 className='font-weight-bold'>Tv page</h1>
                </div>
            </div>
        </div>
      </section>
    </div>
  )
}

export default Tv
